// libs/fe-foundation — the app-chrome layer, extracted from apps/ats-web at
// Platform-Console Inc-2 PR-1.6 (FE-Foundation Extraction) so platform-web (PR-2)
// can import the richer chrome from scope:shared (the Platform⊥ATS wall forbids
// importing from ats-web). These are the "above-the-frozen-Shell" components the
// mockups need: the collapsible rail/topbar AppShell kit, the account UserMenu,
// the Avatar/EntityCell atoms, the token-styled DataTable, and the icon set.
//
// Domain-neutral (react + react-router only — no @aramo/* domain import). The
// structural CSS ships in ./ui.css (side-effect-imported below); the token
// VARIABLES it consumes stay per-app (see the ui.css header's token contract).
import './ui.css';
// D-ORG-3 — the shared settings-surface grammar (shell rail, section head, rows,
// chips, seams, hints), moved from ats-web so both settings rails render it.
import './settings.css';

export {
  AppShell,
  ShellBrand,
  Rail,
  RailNavItem,
  RailNavLabel,
  RailNavSection,
  RailUser,
  TopBar,
  Breadcrumb,
  CmdKSearch,
  NotificationButton,
  useRailCollapse,
  type BreadcrumbItem,
  type RailCollapse,
} from './AppShell';
export { UserMenu } from './UserMenu';
export { Avatar, EntityCell, initialsOf, type AvatarSize } from './Avatar';
export { DataTable } from './DataTable';
// Dashboard tiles — moved from apps/ats-web at Platform-Console Inc-3 PR-3.8 so
// platform-web's operator dashboard can import them across the Platform⊥ATS wall
// (same move-not-fork discipline as the PR-1.6 chrome carve). Domain-neutral
// (react-only); their structural styles ride ./ui.css (the rc-metric/rc-kpi/
// rc-spark/rc-pace rules carved alongside).
export { MetricCard } from './MetricCard';
export { KpiCard, type KpiDelta, type KpiPace } from './KpiCard';
export { Sparkline, type SparkTone } from './Sparkline';
// SKILL-TAX-1F-C2 — a domain-neutral keyset/cursor paginator (hook + button). The
// cursor is opaque and never decoded here; first consumed by the platform skill
// review queue, reusable by any cursor-backed surface.
export {
  useCursorPager,
  CursorLoadMore,
  type CursorPage,
  type CursorPagerState,
} from './CursorPager';
// D-ORG-3 (Organization Administration carve) — shared view atoms moved from
// apps/ats-web/src/ui (move-not-fork): the surface card, the domain-neutral
// chips, the product-safe error fallback and the settings section primitives.
// ats-web re-exports them from its own ui/ + settings/ barrels (call-sites
// unchanged); libs/org-admin-web imports them from here.
export { SurfaceCard, SurfaceCardHead } from './SurfaceCard';
export { StatusPill, Tag, TagList, type PillTone } from './pills';
export { safeErrorMessage } from './errors';
export {
  SettingsSection,
  StatChip,
  SettingRow,
  SettingCardHead,
  SettingHint,
  SettingsSeam,
  SettingsHeadlessProvider,
} from './SettingsPrimitives';
